"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _formCard = _interopRequireDefault(require("../form-card"));

var _formDialog = _interopRequireDefault(require("../form-dialog"));

var _attach = _interopRequireDefault(require("../attach"));

var _button = _interopRequireDefault(require("../button"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _confirmationDialog = _interopRequireDefault(require("../confirmation-dialog"));

var _access = _interopRequireDefault(require("mson/lib/access"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

require("./collection-field.css");

var _selectOrder = _interopRequireDefault(require("./select-order"));

var _buttonField = _interopRequireDefault(require("mson/lib/fields/button-field"));

var _icon = _interopRequireDefault(require("../icon"));

var _commonField = _interopRequireDefault(require("./common-field"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _collectionField2 = _interopRequireDefault(require("mson/lib/fields/collection-field"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getItemStyle = function getItemStyle(isDragging, draggableStyle, theme) {
  return _objectSpread({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: theme.spacing(0.125),
    margin: "0 0 ".concat(theme.spacing(0.125), "px 0"),
    // change background colour if dragging
    background: isDragging ? theme.palette.secondary[400] : undefined
  }, draggableStyle);
};

var getListStyle = function getListStyle(isDraggingOver, theme) {
  return {
    background: isDraggingOver ? theme.palette.grey[300] : undefined,
    width: '100%'
  };
}; // Note:
//   - We use a dialog to view/edit the forms as we want to be able to display just a few pieces
//     of data in the list and all the data when viewing/editing.


var styles = function styles(theme) {
  return {
    root: {
      // Needed when field is nested in a form that is nested in a form, e.g. FormEditor
      width: '100%'
    },
    spacer: {
      backgroundColor: theme.palette.grey[300],
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      animation: 'fadeIn 1s infinite alternate'
    },
    footer: {
      // Create space at the footer so that it is more evident to the user that the next page has been
      // loaded
      height: 50,
      backgroundColor: theme.palette.grey[300],
      margin: theme.spacing(1),
      animation: 'fadeIn 1s infinite alternate'
    }
  };
};

var CollectionField = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(CollectionField, _React$PureComponent);

  var _super = _createSuper(CollectionField);

  function CollectionField() {
    var _this;

    (0, _classCallCheck2.default)(this, CollectionField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      sortBy: '',
      sortOrder: 'ASC'
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClose", function () {
      _this.props.component.set({
        mode: null
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCancel", function (form) {
      var _this$props = _this.props,
          component = _this$props.component,
          preventReadAction = _this$props.preventReadAction;

      if (component.get('skipRead') || preventReadAction) {
        component.set({
          mode: null
        });
      } else {
        component.set({
          currentForm: form,
          mode: _collectionField2.default.MODES.READ
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function (form) {
      var component = _this.props.component;

      if (component.get('skipRead')) {
        component.set({
          currentForm: form,
          mode: _collectionField2.default.MODES.UPDATE
        });
      } else {
        component.set({
          currentForm: form,
          mode: _collectionField2.default.MODES.READ
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleEdit", function (form) {
      _this.props.component.set({
        currentForm: form,
        mode: _collectionField2.default.MODES.UPDATE
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleNew", function () {
      _this.props.component.set({
        currentForm: null,
        mode: _collectionField2.default.MODES.CREATE
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSave", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.component.save();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDelete", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(formToDelete) {
        var component, form, archivedAt;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                component = _this.props.component;
                form = formToDelete ? formToDelete : component.get('form');
                archivedAt = form.getValue('archivedAt'); // Are we restoring?

                if (archivedAt) {
                  component.set({
                    currentForm: form,
                    mode: _collectionField2.default.MODES.RESTORE
                  });
                } else if (formToDelete) {
                  component.set({
                    currentForm: formToDelete,
                    mode: _collectionField2.default.MODES.DELETE
                  });
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleConfirmationClose", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(yes) {
        var component;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                component = _this.props.component;

                if (!yes) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return component.archive(component.get('form'));

              case 4:
                component.set({
                  mode: null
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOrdering", function (props) {
      // TODO: shouldn't the ordering just be in the field and not have to be in this state?
      _this.setState(props, function () {
        _this.props.component.set({
          order: _this.state.sortBy ? [[_this.state.sortBy, _this.state.sortOrder]] : null
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDragEnd", function (result) {
      // dropped outside the list
      if (!result.destination) {
        return;
      }

      if (result.destination.index !== result.source.index) {
        _this.props.component.moveAndSaveForm({
          sourceIndex: result.source.index,
          destinationIndex: result.destination.index
        });
      }
    });
    return _this;
  }

  (0, _createClass2.default)(CollectionField, [{
    key: "canCreate",
    value: function canCreate() {
      return _access.default.canCreate(this.props.component.get('form'));
    }
  }, {
    key: "canUpdate",
    value: function canUpdate() {
      return _access.default.canUpdate(this.props.component.get('form'));
    }
  }, {
    key: "canArchive",
    value: function canArchive() {
      return _access.default.canArchive(this.props.component.get('form'));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.bufferTopId !== prevProps.bufferTopId) {
        // Resize the spacer now that the newly prepended items have been rendered
        this.props.component._infiniteLoader.resizeSpacer(this.props.bufferTopId);
      }

      if (this.props.spacerHeight !== prevProps.spacerHeight) {
        this.props.component._infiniteLoader.setSpacerResizing(false);
      }

      if (this.props.change !== prevProps.change) {
        this.props.component.set({
          isLoading: false
        });
      }
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      var _this$props2 = this.props,
          forbidOrder = _this$props2.forbidOrder,
          showArchived = _this$props2.showArchived,
          searchString = _this$props2.searchString,
          order = _this$props2.order; // Can we order by dragging?

      return !forbidOrder && !showArchived && !searchString && !order;
    }
  }, {
    key: "cards",
    value: function cards(canUpdate, canArchive) {
      var _this2 = this;

      var _this$props3 = this.props,
          component = _this$props3.component,
          forbidUpdate = _this$props3.forbidUpdate,
          forbidDelete = _this$props3.forbidDelete,
          forbidOrder = _this$props3.forbidOrder,
          editable = _this$props3.editable,
          disabled = _this$props3.disabled,
          useDisplayValue = _this$props3.useDisplayValue,
          theme = _this$props3.theme; // Force to 1 colum when ordering allowed

      var maxColumns = forbidOrder === false ? 1 : this.props.maxColumns;
      var maxGrids = 12 / maxColumns;
      var cards = [];
      var index = 0;

      var _iterator = _createForOfIteratorHelper(component.getForms()),
          _step;

      try {
        var _loop = function _loop() {
          var form = _step.value;
          // TODO: Rendering should not change form. Use utils.getIfDefined() in form to allow passing
          // in of editable via React layer
          form.setEditable(false); // We need to use the id for the key as we use the same list of cards when toggling
          // showArchive

          var key = form.getUniqueId(); // Note: we use an id instead of ref so that more of our logic can be reused across different
          // frameworks. We use the form id so that we have a consistent way of referencing the element
          // for things like infinite loading.

          var id = component.getUniqueItemId(component._getFormKey(form));
          var formExtras = component.getFormExtras(form);

          var item = /*#__PURE__*/_react.default.createElement(_Grid.default, {
            item: true,
            xs: 12,
            sm: maxGrids,
            lg: maxGrids,
            key: key,
            id: id
          }, /*#__PURE__*/_react.default.createElement(_formCard.default, {
            onClick: function onClick() {
              return _this2.handleClick(form);
            },
            onEdit: function onEdit() {
              return _this2.handleEdit(form);
            },
            onDelete: _this2.handleDelete,
            component: form,
            forbidUpdate: forbidUpdate || !canUpdate || useDisplayValue,
            forbidDelete: forbidDelete || !canArchive || useDisplayValue,
            editable: editable,
            disabled: disabled,
            buttons: formExtras === null || formExtras === void 0 ? void 0 : formExtras.buttons,
            id: id,
            "aria-label": "View ".concat(id)
          }));

          if (_this2.canDrag()) {
            cards.push( /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Draggable, {
              key: id,
              draggableId: id,
              index: index++
            }, function (provided, snapshot) {
              return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
                ref: provided.innerRef
              }, provided.draggableProps, provided.dragHandleProps, {
                style: getItemStyle(snapshot.isDragging, provided.draggableProps.style, theme),
                "aria-label": "Drag ".concat(id)
              }), item);
            }));
          } else {
            cards.push(item);
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return cards;
    }
  }, {
    key: "sortOptions",
    value: function sortOptions() {
      var component = this.props.component;

      if (component && component.get('form')) {
        var form = component.get('form');

        var fieldsCanAccess = _access.default.fieldsCanAccess('read', form);

        var fields = [];
        form.eachField(function (field) {
          var name = field.get('name'); // Do we have access to the field? Allowed to sort? Not hidden? Not a button?

          if (fieldsCanAccess[name] !== undefined && !field.get('forbidSort') && !field.get('hidden') && !(field instanceof _buttonField.default)) {
            fields.push({
              value: (form.isDefaultField(name) ? '' : 'fieldValues.') + name,
              label: field.get('label')
            });
          }
        });
        return fields;
      }
    }
  }, {
    key: "header",
    value: function header(numCards) {
      var _this$props4 = this.props,
          forbidCreate = _this$props4.forbidCreate,
          editable = _this$props4.editable,
          disabled = _this$props4.disabled,
          component = _this$props4.component,
          forbidSort = _this$props4.forbidSort,
          store = _this$props4.store,
          useDisplayValue = _this$props4.useDisplayValue;
      var _this$state = this.state,
          sortBy = _this$state.sortBy,
          sortOrder = _this$state.sortOrder;
      var singularLabel = component.getSingularLabel();
      var reachedMax = component.reachedMax();
      var canCreate = this.canCreate();
      var showNewButton = editable && !disabled && !useDisplayValue && !forbidCreate && !reachedMax && canCreate;
      var canOrder = !forbidSort;
      var sortOptions = this.sortOptions(); // Sorting only works when there is a backing store

      var hasStore = !!store;
      var showOrder = numCards > 0 && hasStore;
      return /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        spacing: 0
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        lg: 6
      }, showNewButton ? /*#__PURE__*/_react.default.createElement(_button.default, {
        "aria-label": "new",
        onClick: this.handleNew,
        icon: "Add",
        label: 'New ' + singularLabel,
        marginTop: false
      }) : null), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        lg: 6,
        align: "right"
      }, showOrder && canOrder ? /*#__PURE__*/_react.default.createElement(_selectOrder.default, {
        onChange: this.handleOrdering,
        sortBy: sortBy,
        sortOrder: sortOrder,
        options: sortOptions
      }) : null));
    }
  }, {
    key: "field",
    // TODO: how to prevent re-rendering of all form-cards when dialog open state is changed? Or, does
    // it not really matter as we are using PureComponents?
    value: function field() {
      var _this$props5 = this.props,
          forbidUpdate = _this$props5.forbidUpdate,
          forbidDelete = _this$props5.forbidDelete,
          component = _this$props5.component,
          spacerHeight = _this$props5.spacerHeight,
          classes = _this$props5.classes,
          isLoading = _this$props5.isLoading,
          form = _this$props5.form,
          currentForm = _this$props5.currentForm,
          noResults = _this$props5.noResults,
          disabled = _this$props5.disabled,
          accessEditable = _this$props5.accessEditable,
          useDisplayValue = _this$props5.useDisplayValue,
          theme = _this$props5.theme,
          preventUpdate = _this$props5.preventUpdate,
          preventDeleteAction = _this$props5.preventDeleteAction,
          mode = _this$props5.mode;
      var dis = accessEditable === false || disabled;
      var confirmationOpen = false;
      var confirmationTitle = null;

      if (!preventDeleteAction && currentForm && mode === _collectionField2.default.MODES.DELETE && !currentForm.getValue('archivedAt')) {
        confirmationOpen = true; // confirmationTitle: `Are you sure you want to delete this ${singularLabel}?`

        confirmationTitle = 'Delete this?';
      }

      var label = component.get('label').toLowerCase();
      var canUpdate = this.canUpdate();
      var canArchive = this.canArchive();
      var spacerStyle = {
        height: spacerHeight
      };
      var spacerId = component.get('spacerId');
      var cards = this.cards(canUpdate, canArchive);
      var cardContainer = cards;

      if (this.canDrag()) {
        cardContainer = /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.DragDropContext, {
          onDragEnd: this.onDragEnd
        }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Droppable, {
          droppableId: "droppable"
        }, function (provided, snapshot) {
          return /*#__PURE__*/_react.default.createElement("div", {
            ref: provided.innerRef,
            style: getListStyle(snapshot.isDraggingOver, theme)
          }, cards, provided.placeholder);
        }));
      }

      var searchString = component.get('searchString'); // Is the user searching and there are no records?

      var showNoRecords = searchString && noResults;
      var header = this.header(cards.length);
      return /*#__PURE__*/_react.default.createElement("div", null, header, showNoRecords ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "h4"
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        icon: "Info"
      }), " No ", label, " found") : null, /*#__PURE__*/_react.default.createElement("div", {
        id: spacerId,
        className: classes.spacer,
        style: spacerStyle
      }), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        spacing: 0
      }, cardContainer), isLoading ? /*#__PURE__*/_react.default.createElement("div", {
        className: classes.footer
      }) : null, /*#__PURE__*/_react.default.createElement(_formDialog.default, {
        component: form,
        currentForm: currentForm,
        onClose: this.handleClose,
        onCancel: this.handleCancel,
        onSave: this.handleSave,
        onEdit: this.handleEdit,
        onDelete: this.handleDelete,
        forbidUpdate: forbidUpdate || !canUpdate || dis || useDisplayValue || preventUpdate,
        forbidDelete: forbidDelete || !canArchive || dis || useDisplayValue || preventDeleteAction
      }), /*#__PURE__*/_react.default.createElement(_confirmationDialog.default, {
        open: confirmationOpen,
        onClose: this.handleConfirmationClose,
        title: confirmationTitle
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          component = _this$props6.component,
          hideLabel = _this$props6.hideLabel,
          classes = _this$props6.classes;
      var isBlank = component.isBlank();
      return /*#__PURE__*/_react.default.createElement("span", {
        className: classes.root
      }, !hideLabel && /*#__PURE__*/_react.default.createElement(_commonField.default, {
        component: component,
        inlineLabel: "true",
        shrinkLabel: !isBlank
      }), this.field());
    }
  }]);
  return CollectionField;
}(_react.default.PureComponent);

CollectionField = (0, _withStyles.default)(styles, {
  withTheme: true
})(CollectionField);
CollectionField = (0, _attach.default)(['change', 'label', 'singularLabel', 'forbidCreate', 'forbidUpdate', 'forbidDelete', 'forbidSort', 'forbidOrder', 'editable', 'disabled', 'spacerHeight', 'bufferTopId', 'isLoading', 'form', 'currentForm', 'mode', 'noResults', 'store', 'maxColumns', 'useDisplayValue', 'hideLabel', 'showArchived', 'searchString', 'order', 'preventReadAction', 'preventUpdate', 'preventDeleteAction', 'buttonsFactory'])(CollectionField);
var _default = CollectionField;
exports.default = _default;